import { css } from "styled-components";

import { drawerStyles } from "./drawer";
import { antdInputStyles } from "./input";
import { antdTabsStyles } from "./tabs";
import { tablesStyle } from "./tables";

export const antdStyles = css`
  ${drawerStyles}
  ${antdInputStyles}
  ${antdTabsStyles}
  ${tablesStyle}
`;
